import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import NavDropdown from './NavDropdown';

const TenantHeader = ({ tenant, navItems = [], previewBackTo, previewLabel }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const displayName = tenant?.branding?.displayName || tenant?.name || 'My communities';

  const handleLogout = async () => {
    await logout();
    navigate(tenant?.slug ? `/t/${tenant.slug}/login` : '/login', { replace: true });
  };
  React.useEffect(() => { setMenuOpen(false); }, [location.pathname, location.search]);

  return (
    <div className="tenant-header-container">
      {previewBackTo && (
        <div className="tenant-header__preview-bar">
          <Link to={previewBackTo} className="tenant-header__preview-back">← Platform</Link>
          {previewLabel && <span className="tenant-header__preview-label">{previewLabel}</span>}
        </div>
      )}
      <header className="tenant-header">
        <Link to={tenant?.slug ? `/t/${tenant.slug}/dashboard` : '/dashboard'} className="tenant-header__brand">
          {tenant?.branding?.logoUrl && (
            <img src={tenant.branding.logoUrl} alt={`${displayName} logo`} className="tenant-header__logo" />
          )}
          <span>{displayName}</span>
        </Link>
        <button type="button" className="tenant-header__toggle" aria-label="Toggle community navigation" aria-expanded={menuOpen} onClick={() => setMenuOpen((open) => !open)}>
          <span></span><span></span><span></span>
        </button>
        <div className={`tenant-header__menu${menuOpen ? ' open' : ''}`} onClick={() => setMenuOpen(false)}>
          {navItems.map((item) =>
            item.children ? (
              <NavDropdown key={item.label} label={item.label} items={item.children} />
            ) : (
              <Link key={item.to} to={item.to}>{item.label}</Link>
            )
          )}
          <NavDropdown label="My account" items={[
            { to: tenant?.slug ? `/t/${tenant.slug}/account` : '/account', label: 'Account settings' },
            { to: tenant?.slug ? `/t/${tenant.slug}/my-data` : '/my-data', label: 'My data' },
          ]} />
          <button type="button" className="tenant-header__logout" onClick={handleLogout}>Logout</button>
        </div>
      </header>
    </div>
  );
};

export default TenantHeader;
